if (!customElements.get('offer-banners-slider-component')) {
  customElements.whenDefined('slider-component').then(() => {
    class OfferBannersSliderComponent extends SliderComponent {
      constructor() {
        super();
        this.enableSliderLooping = this.getAttribute('data-loop') === 'true';

        // Add click events to pagination dots
        const dots = this.querySelectorAll('.offer-banners__dot');
        dots.forEach((dot) => {
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            const index = parseInt(dot.getAttribute('data-index'), 10);
            this.setSlidePosition(index * this.sliderItemOffset);
          });
        });

        this.initAutoplay();
      }

      initPages() {
        super.initPages();
        if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) {
          const visibleWidth = this.slider.clientWidth;
          this.slidesPerPage = Math.round(visibleWidth / this.sliderItemOffset);
          if (this.slidesPerPage < 1) this.slidesPerPage = 1;
          this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
          if (this.totalPages < 1) this.totalPages = 1;
        }
        this.updateDotsVisibility();
      }

      update() {
        super.update();

        const hasMultiplePages = this.totalPages > 1;

        if (this.enableSliderLooping) {
          if (this.prevButton) {
            if (hasMultiplePages) {
              this.prevButton.removeAttribute('disabled');
              this.prevButton.style.display = '';
            } else {
              this.prevButton.setAttribute('disabled', 'disabled');
              this.prevButton.style.display = 'none';
            }
          }

          if (this.nextButton) {
            if (hasMultiplePages) {
              this.nextButton.removeAttribute('disabled');
              this.nextButton.style.display = '';
            } else {
              this.nextButton.setAttribute('disabled', 'disabled');
              this.nextButton.style.display = 'none';
            }
          }
        }

        // Update active dots
        const dots = this.querySelectorAll('.offer-banners__dot');
        if (dots.length > 0) {
          const scrollPos = this.slider.scrollLeft;
          const activeIndex = Math.round(scrollPos / this.sliderItemOffset);

          dots.forEach((dot, index) => {
            if (index === activeIndex) {
              dot.classList.add('is-active');
            } else {
              dot.classList.remove('is-active');
            }
          });
        }

        this.updateDotsVisibility();
      }

      updateDotsVisibility() {
        const dots = this.querySelectorAll('.offer-banners__dot');
        dots.forEach((dot, index) => {
          if (index < this.totalPages) {
            dot.style.display = '';
          } else {
            dot.style.display = 'none';
          }
        });

        const dotsContainer = this.querySelector('.offer-banners__dots');
        if (dotsContainer) {
          if (this.totalPages <= 1) {
            dotsContainer.style.display = 'none';
          } else {
            dotsContainer.style.display = '';
          }
        }
      }

      onButtonClick(event) {
        event.preventDefault();
        const step = parseInt(event.currentTarget.dataset.step || 1, 10);

        if (this.enableSliderLooping) {
          const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
          const isAtEnd = this.slider.scrollLeft >= maxScroll - 5;
          const isAtStart = this.slider.scrollLeft <= 5;

          if (event.currentTarget.name === 'next') {
            if (isAtEnd) {
              this.slideScrollPosition = 0;
            } else {
              this.slideScrollPosition = this.slider.scrollLeft + step * this.sliderItemOffset;
            }
          } else if (event.currentTarget.name === 'previous') {
            if (isAtStart) {
              this.slideScrollPosition = maxScroll;
            } else {
              this.slideScrollPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
            }
          }
          this.setSlidePosition(this.slideScrollPosition);
        } else {
          super.onButtonClick(event);
        }
      }

      initAutoplay() {
        if (this.getAttribute('data-autoplay') !== 'true') return;

        this.autoplaySpeed = parseInt(this.getAttribute('data-speed') || '5', 10) * 1000;
        this.autoplayInterval = null;

        this.startAutoplay();

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
      }

      startAutoplay() {
        if (this.totalPages <= 1) return;
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => {
          const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
          const isAtEnd = this.slider.scrollLeft >= maxScroll - 5;
          const nextScroll = isAtEnd ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
          this.setSlidePosition(nextScroll);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }
    }

    customElements.define('offer-banners-slider-component', OfferBannersSliderComponent);
  });
}
